<div class="fill-swatches" role="radiogroup" [attr.aria-label]="'document.edit.mediaFill.title' | translate">
    @for (choice of choices; track choice.hex) {
        <button
            type="button"
            class="fill-swatch"
            role="radio"
            [class.current]="value() === choice.hex"
            [class.fill-transparent]="choice.hex === transparent"
            [attr.aria-checked]="value() === choice.hex"
            [attr.aria-label]="choice.labelKey | translate"
            [raEditTooltip]="{ text: (choice.labelKey | translate), position: 'top' }"
            [style.background-color]="choice.hex === transparent ? null : choice.hex"
            [disabled]="disabled()"
            (click)="select(choice.hex)">
        </button>
    }
    <custom-color-swatch
        [value]="pickerValue()"
        [current]="isCustom()"
        [disabled]="disabled()"
        [label]="'document.edit.mediaFill.custom' | translate"
        (preview)="onCustomPreview($event)"
        (choose)="onCustomChoose($event)" />
</div>
